import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Newsletter() {
  const {
    t
  } = useLanguage();
  const [submitted, setSubmitted] = useState(false);
  // NOTE: No email backend / ESP is connected yet. We acknowledge the user
  // locally but do NOT persist the address. Wire this to an email platform
  // (Mailchimp, Resend, etc.) before relying on captured signups.
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section className="py-20 md:py-32 relative z-10" data-id="element-224">
      <div className="max-w-4xl mx-auto px-5 sm:px-6" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="glass-panel rounded-[2.5rem] p-8 md:p-16 border border-white/10 text-center relative overflow-hidden" data-id="element-226">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(255,106,0,0.1),transparent_70%)]" data-id="element-227" />

          <div className="relative z-10" data-id="element-228">
            <h2 className="text-[40px] leading-[1.05] md:text-5xl lg:text-6xl font-display font-medium mb-4 md:mb-6" data-id="element-229">
              {t('newsletter.title')}
            </h2>
            <p className="text-white/60 text-[18px] leading-[1.5] md:text-xl mb-10 md:mb-12 max-w-2xl mx-auto font-light" data-id="element-230">
              {t('newsletter.subtitle')}
            </p>

            {submitted ? <div role="status" aria-live="polite" className="flex items-center justify-center gap-2 max-w-md mx-auto bg-surface/50 border border-white/10 rounded-full px-8 py-4 text-white font-light" data-id="element-231">
                <Check className="w-5 h-5 text-accent shrink-0" data-id="element-232" />
                {t('newsletter.success')}
              </div> : <form className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" onSubmit={handleSubmit} data-id="element-233">
                <label htmlFor="newsletter-email" className="sr-only" data-id="element-234">
                  {t('newsletter.label')}
                </label>
                <input id="newsletter-email" name="email" type="email" placeholder={t('newsletter.placeholder')} className="flex-1 bg-surface/50 border border-white/10 rounded-full px-6 md:px-8 h-[56px] md:h-auto py-4 text-[16px] text-white placeholder:text-white/30 focus:outline-none focus:ring-2 focus:ring-accent/50 focus:border-white/30 focus:bg-surface/80 transition-all font-light shadow-[inset_0_2px_8px_rgba(0,0,0,0.2)]" required data-id="element-235" />
                <button type="submit" className="bg-white text-background px-8 h-[56px] md:h-auto py-4 rounded-full text-[16px] md:text-base font-medium md:hover:bg-white/90 md:hover:-translate-y-0.5 md:hover:shadow-[0_8px_20px_rgba(255,255,255,0.15)] active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-white/50 transition-all duration-300 flex items-center justify-center gap-2 shrink-0" data-id="element-236">
                  {t('newsletter.cta')} <ArrowRight className="w-4 h-4" data-id="element-237" />
                </button>
              </form>}
            <p className="text-white/30 text-[13px] md:text-xs mt-6 font-light" data-id="element-238">
              {t('newsletter.disclaimer')}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}